import { render } from "./iconMaterial.vue?vue&type=template&id=8e810dda&ts=true"
import script from "./iconMaterial.vue?vue&type=script&lang=ts"
export * from "./iconMaterial.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__